class ProductGallery extends window.MDLR.CustomElement {
  static get requiredElements() {
    return ["track", "dots"];
  }

  connectedCallback() {
    super.connectedCallback();
    this.initCarousel();
  }

  disconnectedCallback() {
    this.destroyCarousel();
    super.disconnectedCallback();
  }

  setupListeners() {
    super.setupListeners();
  }

  initCarousel() {
    if (this.emblaApi || !this.track) return;

    const Embla = window.EmblaCarousel;
    if (!Embla) {
      window.addEventListener("load", () => this.initCarousel(), {
        once: true,
      });
      return;
    }

    if (this.track.children.length <= 1) {
      this.dots.innerHTML = "";
      return;
    }

    const options = {
      loop: true,
      active: true,
      breakpoints: {
        "(min-width: 640px)": { active: false },
      },
    };

    this.emblaApi = Embla(this, options);
    this.emblaApi.on("init", () => this.refreshDots());
    this.emblaApi.on("reInit", () => this.refreshDots());
    this.emblaApi.on("select", () => this.updateDots());
    this.emblaApi.on("destroy", () => this.cleanupDots());

    this.refreshDots();
  }

  refreshDots() {
    if (!this.emblaApi) return;

    const dotCount = this.emblaApi.scrollSnapList().length;
    if (!dotCount) return;

    if (!this.dotListeners) {
      this.dotListeners = new window.MDLR.Listeners();
    }

    this.dots.innerHTML = Array.from({ length: dotCount })
      .map(() => '<button class="product-images__dot" type="button"></button>')
      .join("");

    this.dotButtons = Array.from(
      this.dots.querySelectorAll(".product-images__dot")
    );

    this.dotButtons.forEach((button, index) => {
      this.dotListeners.add(button, "click", () => {
        this.emblaApi?.scrollTo(index);
      });
    });

    this.updateDots();
  }

  updateDots() {
    if (!this.emblaApi || !this.dotButtons?.length) return;

    const selected = this.emblaApi.selectedScrollSnap();
    this.dotButtons.forEach((button, index) => {
      button.classList.toggle(
        "product-images__dot--selected",
        index === selected
      );
    });
  }

  cleanupDots() {
    this.dotListeners.removeAll();
    this.dotButtons = [];
    this.dots.innerHTML = "";
  }

  destroyCarousel() {
    if (this.emblaApi) {
      this.emblaApi.destroy();
      this.emblaApi = null;
    }

    this.cleanupDots();
  }

  get track() {
    return this.getElement("track");
  }

  get dots() {
    return this.getElement("dots");
  }
}

if (!customElements.get("product-gallery")) {
  customElements.define("product-gallery", ProductGallery);
}
